import { useState, useRef } from 'react'

export const FilterSelection = (props) => {

  const items = JSON.parse(props.items)
  const secondaryItems = JSON.parse(props.secondaryItems)
  const showSecondary = secondaryItems && secondaryItems.length > 0

  const activeItem = items.find((item) => item.title === props.title)
  const activeItemIsSecondaryItem = !items.includes(activeItem)

  const [showDropdownContent, setShowDropdownContent] = useState(false)

  const handleClick = props.onClick || ((item) => { window.location.href = item.url })

  return <div className="module-filter-selection">
    {showDropdownContent && <Backdrop setShowDropdownContent={setShowDropdownContent} />}
    <button className='module-filter-selection__toggle' onClick={() => setShowDropdownContent(!showDropdownContent)}>
      {props.title}
    </button>
    {showDropdownContent &&
      <ul className='module-filter-selection__content mt-1'>
        {items.map((item, index) =>
          <li className={`module-filter-selection__item p-2 ${item === activeItem && 'font-bold'}`} key={index} onClick={() => handleClick(item)}>
            {item.title}
          </li>)
        }
        {showSecondary &&
          <ClosedProductList activeItemIsSecondaryItem={activeItemIsSecondaryItem} >
            {secondaryItems.map((item, index) =>
              <li className={`module-filter-selection__item p-2 ${item.title === props.title && 'font-bold'}`} key={index} onClick={() => handleClick(item)}>
                {item.title}
              </li>)
            }
          </ClosedProductList>
        }
      </ul>
    }
  </div>
}

const ClosedProductList = (props) => {
  const [showClosedProducts, setShowClosedProducts] = useState(props.activeItemIsSecondaryItem ? true : false)

  return <div>
    <button className='simulated-link p-2 cursor-pointer' onClick={() => setShowClosedProducts(!showClosedProducts)}>{!showClosedProducts ? I18n.t('modules.filter_selection.show_closed_projects') : I18n.t('modules.filter_selection.hide_closed_projects')}</button>
    {showClosedProducts && props.children}
  </div>
}

const Backdrop = ({ setShowDropdownContent }) => {
  const style = {
    backgroundColor: 'black',
    opacity: 0.1,
    position: 'fixed',
    zIndex: 999997,
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    outline: 0,
    transition: 'opacity 0.15s linear',
  }
  return <div style={style} onClick={() => setShowDropdownContent(false)} />
}
